module.exports = __webpack_public_path__ + "img/20-2.4e2eb740.jpg";